var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export { default as Icone } from './Icone';
export * from './Icone.types';
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAncientGateFill
 */
export var ancientGateFill = "fr-icon-ancient-gate-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAncientGateLine
 */
export var ancientGateLine = "fr-icon-ancient-gate-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAncientPavilionFill
 */
export var ancientPavilionFill = "fr-icon-ancient-pavilion-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAncientPavilionLine
 */
export var ancientPavilionLine = "fr-icon-ancient-pavilion-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBankFill
 */
export var bankFill = "fr-icon-bank-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBankLine
 */
export var bankLine = "fr-icon-bank-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBuildingFill
 */
export var buildingFill = "fr-icon-building-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBuildingLine
 */
export var buildingLine = "fr-icon-building-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCommunityFill
 */
export var communityFill = "fr-icon-community-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCommunityLine
 */
export var communityLine = "fr-icon-community-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGovernmentFill
 */
export var governmentFill = "fr-icon-government-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGovernmentLine
 */
export var governmentLine = "fr-icon-government-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHome4Fill
 */
export var home4Fill = "fr-icon-home-4-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHome4Line
 */
export var home4Line = "fr-icon-home-4-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHospitalFill
 */
export var hospitalFill = "fr-icon-hospital-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHospitalLine
 */
export var hospitalLine = "fr-icon-hospital-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHotelFill
 */
export var hotelFill = "fr-icon-hotel-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHotelLine
 */
export var hotelLine = "fr-icon-hotel-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStoreFill
 */
export var storeFill = "fr-icon-store-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStoreLine
 */
export var storeLine = "fr-icon-store-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesBuilding = [
    ancientGateFill,
    ancientGateLine,
    ancientPavilionFill,
    ancientPavilionLine,
    bankFill,
    bankLine,
    buildingFill,
    buildingLine,
    communityFill,
    communityLine,
    governmentFill,
    governmentLine,
    home4Fill,
    home4Line,
    hospitalFill,
    hospitalLine,
    hotelFill,
    hotelLine,
    storeFill,
    storeLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArchiveFill
 */
export var archiveFill = "fr-icon-archive-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArchiveLine
 */
export var archiveLine = "fr-icon-archive-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAttachmentFill
 */
export var attachmentFill = "fr-icon-attachment-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAttachmentLine
 */
export var attachmentLine = "fr-icon-attachment-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAwardFill
 */
export var awardFill = "fr-icon-award-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAwardLine
 */
export var awardLine = "fr-icon-award-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBarChartBoxFill
 */
export var barChartBoxFill = "fr-icon-bar-chart-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBarChartBoxLine
 */
export var barChartBoxLine = "fr-icon-bar-chart-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBookmarkFill
 */
export var bookmarkFill = "fr-icon-bookmark-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBookmarkLine
 */
export var bookmarkLine = "fr-icon-bookmark-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBriefcaseFill
 */
export var briefcaseFill = "fr-icon-briefcase-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBriefcaseLine
 */
export var briefcaseLine = "fr-icon-briefcase-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCalendar2Fill
 */
export var calendar2Fill = "fr-icon-calendar-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCalendar2Line
 */
export var calendar2Line = "fr-icon-calendar-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCalendarEventFill
 */
export var calendarEventFill = "fr-icon-calendar-event-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCalendarEventLine
 */
export var calendarEventLine = "fr-icon-calendar-event-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCalendarFill
 */
export var calendarFill = "fr-icon-calendar-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCalendarLine
 */
export var calendarLine = "fr-icon-calendar-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloudFill
 */
export var cloudFill = "fr-icon-cloud-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloudLine
 */
export var cloudLine = "fr-icon-cloud-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCopyrightFill
 */
export var copyrightFill = "fr-icon-copyright-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCopyrightLine
 */
export var copyrightLine = "fr-icon-copyright-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCustomerServiceFill
 */
export var customerServiceFill = "fr-icon-customer-service-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCustomerServiceLine
 */
export var customerServiceLine = "fr-icon-customer-service-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFlagFill
 */
export var flagFill = "fr-icon-flag-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFlagLine
 */
export var flagLine = "fr-icon-flag-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGlobalFill
 */
export var globalFill = "fr-icon-global-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGlobalLine
 */
export var globalLine = "fr-icon-global-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLineChartFill
 */
export var lineChartFill = "fr-icon-line-chart-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLineChartLine
 */
export var lineChartLine = "fr-icon-line-chart-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLinksFill
 */
export var linksFill = "fr-icon-links-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLinksLine
 */
export var linksLine = "fr-icon-links-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMailFill
 */
export var mailFill = "fr-icon-mail-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMailLine
 */
export var mailLine = "fr-icon-mail-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMailOpenFill
 */
export var mailOpenFill = "fr-icon-mail-open-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMailOpenLine
 */
export var mailOpenLine = "fr-icon-mail-open-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMedalFill
 */
export var medalFill = "fr-icon-medal-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMedalLine
 */
export var medalLine = "fr-icon-medal-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPieChart2Fill
 */
export var pieChart2Fill = "fr-icon-pie-chart-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPieChart2Line
 */
export var pieChart2Line = "fr-icon-pie-chart-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPieChartBoxFill
 */
export var pieChartBoxFill = "fr-icon-pie-chart-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPieChartBoxLine
 */
export var pieChartBoxLine = "fr-icon-pie-chart-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPrinterFill
 */
export var printerFill = "fr-icon-printer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPrinterLine
 */
export var printerLine = "fr-icon-printer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrProfilFill
 */
export var profilFill = "fr-icon-profil-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrProfilLine
 */
export var profilLine = "fr-icon-profil-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrProjector2Fill
 */
export var projector2Fill = "fr-icon-projector-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrProjector2Line
 */
export var projector2Line = "fr-icon-projector-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSendPlaneFill
 */
export var sendPlaneFill = "fr-icon-send-plane-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSendPlaneLine
 */
export var sendPlaneLine = "fr-icon-send-plane-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSlideshowFill
 */
export var slideshowFill = "fr-icon-slideshow-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSlideshowLine
 */
export var slideshowLine = "fr-icon-slideshow-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrWindowFill
 */
export var windowFill = "fr-icon-window-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrWindowLine
 */
export var windowLine = "fr-icon-window-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesBusiness = [
    archiveFill,
    archiveLine,
    attachmentFill,
    attachmentLine,
    awardFill,
    awardLine,
    barChartBoxFill,
    barChartBoxLine,
    bookmarkFill,
    bookmarkLine,
    briefcaseFill,
    briefcaseLine,
    calendar2Fill,
    calendar2Line,
    calendarEventFill,
    calendarEventLine,
    calendarFill,
    calendarLine,
    cloudFill,
    cloudLine,
    copyrightFill,
    copyrightLine,
    customerServiceFill,
    customerServiceLine,
    flagFill,
    flagLine,
    globalFill,
    globalLine,
    lineChartFill,
    lineChartLine,
    linksFill,
    linksLine,
    mailFill,
    mailLine,
    mailOpenFill,
    mailOpenLine,
    medalFill,
    medalLine,
    pieChart2Fill,
    pieChart2Line,
    pieChartBoxFill,
    pieChartBoxLine,
    printerFill,
    printerLine,
    profilFill,
    profilLine,
    projector2Fill,
    projector2Line,
    sendPlaneFill,
    sendPlaneLine,
    slideshowFill,
    slideshowLine,
    windowFill,
    windowLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChat2Fill
 */
export var chat2Fill = "fr-icon-chat-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChat2Line
 */
export var chat2Line = "fr-icon-chat-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChat3Fill
 */
export var chat3Fill = "fr-icon-chat-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChat3Line
 */
export var chat3Line = "fr-icon-chat-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChatCheckFill
 */
export var chatCheckFill = "fr-icon-chat-check-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChatCheckLine
 */
export var chatCheckLine = "fr-icon-chat-check-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChatDeleteFill
 */
export var chatDeleteFill = "fr-icon-chat-delete-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChatDeleteLine
 */
export var chatDeleteLine = "fr-icon-chat-delete-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChatPollFill
 */
export var chatPollFill = "fr-icon-chat-poll-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChatPollLine
 */
export var chatPollLine = "fr-icon-chat-poll-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDiscussFill
 */
export var discussFill = "fr-icon-discuss-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDiscussLine
 */
export var discussLine = "fr-icon-discuss-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFeedbackFill
 */
export var feedbackFill = "fr-icon-feedback-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFeedbackLine
 */
export var feedbackLine = "fr-icon-feedback-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMessage2Fill
 */
export var message2Fill = "fr-icon-message-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMessage2Line
 */
export var message2Line = "fr-icon-message-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuestionAnswerFill
 */
export var questionAnswerFill = "fr-icon-question-answer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuestionAnswerLine
 */
export var questionAnswerLine = "fr-icon-question-answer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuestionnaireFill
 */
export var questionnaireFill = "fr-icon-questionnaire-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuestionnaireLine
 */
export var questionnaireLine = "fr-icon-questionnaire-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVideoChatFill
 */
export var videoChatFill = "fr-icon-video-chat-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVideoChatLine
 */
export var videoChatLine = "fr-icon-video-chat-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesCommunication = [
    chat2Fill,
    chat2Line,
    chat3Fill,
    chat3Line,
    chatCheckFill,
    chatCheckLine,
    chatDeleteFill,
    chatDeleteLine,
    chatPollFill,
    chatPollLine,
    discussFill,
    discussLine,
    feedbackFill,
    feedbackLine,
    message2Fill,
    message2Line,
    questionAnswerFill,
    questionAnswerLine,
    questionnaireFill,
    questionnaireLine,
    videoChatFill,
    videoChatLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBallPenFill
 */
export var ballPenFill = "fr-icon-ball-pen-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBallPenLine
 */
export var ballPenLine = "fr-icon-ball-pen-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBrush3Fill
 */
export var brush3Fill = "fr-icon-brush-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBrush3Line
 */
export var brush3Line = "fr-icon-brush-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBrushFill
 */
export var brushFill = "fr-icon-brush-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBrushLine
 */
export var brushLine = "fr-icon-brush-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrContrastFill
 */
export var contrastFill = "fr-icon-contrast-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrContrastLine
 */
export var contrastLine = "fr-icon-contrast-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCropFill
 */
export var cropFill = "fr-icon-crop-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCropLine
 */
export var cropLine = "fr-icon-crop-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDragMove2Fill
 */
export var dragMove2Fill = "fr-icon-drag-move-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDragMove2Line
 */
export var dragMove2Line = "fr-icon-drag-move-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDropFill
 */
export var dropFill = "fr-icon-drop-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDropLine
 */
export var dropLine = "fr-icon-drop-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEditBoxFill
 */
export var editBoxFill = "fr-icon-edit-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEditBoxLine
 */
export var editBoxLine = "fr-icon-edit-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEditFill
 */
export var editFill = "fr-icon-edit-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEditLine
 */
export var editLine = "fr-icon-edit-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInkBottleFill
 */
export var inkBottleFill = "fr-icon-ink-bottle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInkBottleLine
 */
export var inkBottleLine = "fr-icon-ink-bottle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLayoutGridFill
 */
export var layoutGridFill = "fr-icon-layout-grid-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLayoutGridLine
 */
export var layoutGridLine = "fr-icon-layout-grid-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMarkPenFill
 */
export var markPenFill = "fr-icon-mark-pen-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMarkPenLine
 */
export var markPenLine = "fr-icon-mark-pen-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPaintBrushFill
 */
export var paintBrushFill = "fr-icon-paint-brush-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPaintBrushLine
 */
export var paintBrushLine = "fr-icon-paint-brush-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPaintFill
 */
export var paintFill = "fr-icon-paint-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPaintLine
 */
export var paintLine = "fr-icon-paint-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPaletteFill
 */
export var paletteFill = "fr-icon-palette-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPaletteLine
 */
export var paletteLine = "fr-icon-palette-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPantoneFill
 */
export var pantoneFill = "fr-icon-pantone-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPantoneLine
 */
export var pantoneLine = "fr-icon-pantone-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPenNibFill
 */
export var penNibFill = "fr-icon-pen-nib-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPenNibLine
 */
export var penNibLine = "fr-icon-pen-nib-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPencilFill
 */
export var pencilFill = "fr-icon-pencil-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPencilLine
 */
export var pencilLine = "fr-icon-pencil-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPencilRulerFill
 */
export var pencilRulerFill = "fr-icon-pencil-ruler-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPencilRulerLine
 */
export var pencilRulerLine = "fr-icon-pencil-ruler-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSipFill
 */
export var sipFill = "fr-icon-sip-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSipLine
 */
export var sipLine = "fr-icon-sip-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTableFill
 */
export var tableFill = "fr-icon-table-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTableLine
 */
export var tableLine = "fr-icon-table-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesDesign = [
    ballPenFill,
    ballPenLine,
    brush3Fill,
    brush3Line,
    brushFill,
    brushLine,
    contrastFill,
    contrastLine,
    cropFill,
    cropLine,
    dragMove2Fill,
    dragMove2Line,
    dropFill,
    dropLine,
    editBoxFill,
    editBoxLine,
    editFill,
    editLine,
    inkBottleFill,
    inkBottleLine,
    layoutGridFill,
    layoutGridLine,
    markPenFill,
    markPenLine,
    paintBrushFill,
    paintBrushLine,
    paintFill,
    paintLine,
    paletteFill,
    paletteLine,
    pantoneFill,
    pantoneLine,
    penNibFill,
    penNibLine,
    pencilFill,
    pencilLine,
    pencilRulerFill,
    pencilRulerLine,
    sipFill,
    sipLine,
    tableFill,
    tableLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBugFill
 */
export var bugFill = "fr-icon-bug-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBugLine
 */
export var bugLine = "fr-icon-bug-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCodeBoxFill
 */
export var codeBoxFill = "fr-icon-code-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCodeBoxLine
 */
export var codeBoxLine = "fr-icon-code-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCodeSSlashLine
 */
export var codeSSlashLine = "fr-icon-code-s-slash-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCursorFill
 */
export var cursorFill = "fr-icon-cursor-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCursorLine
 */
export var cursorLine = "fr-icon-cursor-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitBranchFill
 */
export var gitBranchFill = "fr-icon-git-branch-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitBranchLine
 */
export var gitBranchLine = "fr-icon-git-branch-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitCommitFill
 */
export var gitCommitFill = "fr-icon-git-commit-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitCommitLine
 */
export var gitCommitLine = "fr-icon-git-commit-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitMergeFill
 */
export var gitMergeFill = "fr-icon-git-merge-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitMergeLine
 */
export var gitMergeLine = "fr-icon-git-merge-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitPullRequestFill
 */
export var gitPullRequestFill = "fr-icon-git-pull-request-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitPullRequestLine
 */
export var gitPullRequestLine = "fr-icon-git-pull-request-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitRepositoryCommitsFill
 */
export var gitRepositoryCommitsFill = "fr-icon-git-repository-commits-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitRepositoryCommitsLine
 */
export var gitRepositoryCommitsLine = "fr-icon-git-repository-commits-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitRepositoryFill
 */
export var gitRepositoryFill = "fr-icon-git-repository-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitRepositoryLine
 */
export var gitRepositoryLine = "fr-icon-git-repository-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitRepositoryPrivateFill
 */
export var gitRepositoryPrivateFill = "fr-icon-git-repository-private-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGitRepositoryPrivateLine
 */
export var gitRepositoryPrivateLine = "fr-icon-git-repository-private-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTerminalBoxFill
 */
export var terminalBoxFill = "fr-icon-terminal-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTerminalBoxLine
 */
export var terminalBoxLine = "fr-icon-terminal-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTerminalLine
 */
export var terminalLine = "fr-icon-terminal-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTerminalWindowFill
 */
export var terminalWindowFill = "fr-icon-terminal-window-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTerminalWindowLine
 */
export var terminalWindowLine = "fr-icon-terminal-window-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesDevelopment = [
    bugFill,
    bugLine,
    codeBoxFill,
    codeBoxLine,
    codeSSlashLine,
    cursorFill,
    cursorLine,
    gitBranchFill,
    gitBranchLine,
    gitCommitFill,
    gitCommitLine,
    gitMergeFill,
    gitMergeLine,
    gitPullRequestFill,
    gitPullRequestLine,
    gitRepositoryCommitsFill,
    gitRepositoryCommitsLine,
    gitRepositoryFill,
    gitRepositoryLine,
    gitRepositoryPrivateFill,
    gitRepositoryPrivateLine,
    terminalBoxFill,
    terminalBoxLine,
    terminalLine,
    terminalWindowFill,
    terminalWindowLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBluetoothFill
 */
export var bluetoothFill = "fr-icon-bluetooth-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBluetoothLine
 */
export var bluetoothLine = "fr-icon-bluetooth-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrComputerFill
 */
export var computerFill = "fr-icon-computer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrComputerLine
 */
export var computerLine = "fr-icon-computer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDashboard3Fill
 */
export var dashboard3Fill = "fr-icon-dashboard-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDashboard3Line
 */
export var dashboard3Line = "fr-icon-dashboard-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDatabaseFill
 */
export var databaseFill = "fr-icon-database-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDatabaseLine
 */
export var databaseLine = "fr-icon-database-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDeviceFill
 */
export var deviceFill = "fr-icon-device-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDeviceLine
 */
export var deviceLine = "fr-icon-device-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHardDrive2Fill
 */
export var hardDrive2Fill = "fr-icon-hard-drive-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHardDrive2Line
 */
export var hardDrive2Line = "fr-icon-hard-drive-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMacFill
 */
export var macFill = "fr-icon-mac-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMacLine
 */
export var macLine = "fr-icon-mac-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPhoneFill
 */
export var phoneFill = "fr-icon-phone-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPhoneLine
 */
export var phoneLine = "fr-icon-phone-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQRCodeFill
 */
export var qrCodeFill = "fr-icon-qr-code-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQRCodeLine
 */
export var qrCodeLine = "fr-icon-qr-code-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRssFill
 */
export var rssFill = "fr-icon-rss-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRssLine
 */
export var rssLine = "fr-icon-rss-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSave3Fill
 */
export var save3Fill = "fr-icon-save-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSave3Line
 */
export var save3Line = "fr-icon-save-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSaveFill
 */
export var saveFill = "fr-icon-save-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSaveLine
 */
export var saveLine = "fr-icon-save-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrServerFill
 */
export var serverFill = "fr-icon-server-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrServerLine
 */
export var serverLine = "fr-icon-server-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSmartphoneFill
 */
export var smartphoneFill = "fr-icon-smartphone-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSmartphoneLine
 */
export var smartphoneLine = "fr-icon-smartphone-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTabletFill
 */
export var tabletFill = "fr-icon-tablet-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTabletLine
 */
export var tabletLine = "fr-icon-tablet-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTvFill
 */
export var tvFill = "fr-icon-tv-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTvLine
 */
export var tvLine = "fr-icon-tv-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrWifiFill
 */
export var wifiFill = "fr-icon-wifi-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrWifiLine
 */
export var wifiLine = "fr-icon-wifi-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesDevice = [
    bluetoothFill,
    bluetoothLine,
    computerFill,
    computerLine,
    dashboard3Fill,
    dashboard3Line,
    databaseFill,
    databaseLine,
    deviceFill,
    deviceLine,
    hardDrive2Fill,
    hardDrive2Line,
    macFill,
    macLine,
    phoneFill,
    phoneLine,
    qrCodeFill,
    qrCodeLine,
    rssFill,
    rssLine,
    save3Fill,
    save3Line,
    saveFill,
    saveLine,
    serverFill,
    serverLine,
    smartphoneFill,
    smartphoneLine,
    tabletFill,
    tabletLine,
    tvFill,
    tvLine,
    wifiFill,
    wifiLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArticleFill
 */
export var articleFill = "fr-icon-article-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArticleLine
 */
export var articleLine = "fr-icon-article-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBook2Fill
 */
export var book2Fill = "fr-icon-book-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBook2Line
 */
export var book2Line = "fr-icon-book-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBookletFill
 */
export var bookletFill = "fr-icon-booklet-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBookletLine
 */
export var bookletLine = "fr-icon-booklet-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrClipboardFill
 */
export var clipboardFill = "fr-icon-clipboard-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrClipboardLine
 */
export var clipboardLine = "fr-icon-clipboard-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDraftFill
 */
export var draftFill = "fr-icon-draft-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDraftLine
 */
export var draftLine = "fr-icon-draft-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileAddFill
 */
export var fileAddFill = "fr-icon-file-add-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileAddLine
 */
export var fileAddLine = "fr-icon-file-add-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileDownloadFill
 */
export var fileDownloadFill = "fr-icon-file-download-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileDownloadLine
 */
export var fileDownloadLine = "fr-icon-file-download-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileFill
 */
export var fileFill = "fr-icon-file-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileLine
 */
export var fileLine = "fr-icon-file-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFilePdfFill
 */
export var filePdfFill = "fr-icon-file-pdf-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFilePdfLine
 */
export var filePdfLine = "fr-icon-file-pdf-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileTextFill
 */
export var fileTextFill = "fr-icon-file-text-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFileTextLine
 */
export var fileTextLine = "fr-icon-file-text-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFolder2Fill
 */
export var folder2Fill = "fr-icon-folder-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFolder2Line
 */
export var folder2Line = "fr-icon-folder-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNewspaperFill
 */
export var newspaperFill = "fr-icon-newspaper-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNewspaperLine
 */
export var newspaperLine = "fr-icon-newspaper-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSurveyFill
 */
export var surveyFill = "fr-icon-survey-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSurveyLine
 */
export var surveyLine = "fr-icon-survey-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTodoFill
 */
export var todoFill = "fr-icon-todo-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTodoLine
 */
export var todoLine = "fr-icon-todo-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesDocument = [
    articleFill,
    articleLine,
    book2Fill,
    book2Line,
    bookletFill,
    bookletLine,
    clipboardFill,
    clipboardLine,
    draftFill,
    draftLine,
    fileAddFill,
    fileAddLine,
    fileDownloadFill,
    fileDownloadLine,
    fileFill,
    fileLine,
    filePdfFill,
    filePdfLine,
    fileTextFill,
    fileTextLine,
    folder2Fill,
    folder2Line,
    newspaperFill,
    newspaperLine,
    surveyFill,
    surveyLine,
    todoFill,
    todoLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBold
 */
export var bold = "fr-icon-bold";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHighlight
 */
export var highlight = "fr-icon-highlight";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuoteFill
 */
export var quoteFill = "fr-icon-quote-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuoteLine
 */
export var quoteLine = "fr-icon-quote-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCodeView
 */
export var codeView = "fr-icon-code-view";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFontSize
 */
export var fontSize = "fr-icon-font-size";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrH1
 */
export var h1 = "fr-icon-h-1";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrH2
 */
export var h2 = "fr-icon-h-2";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrH3
 */
export var h3 = "fr-icon-h-3";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrH4
 */
export var h4 = "fr-icon-h-4";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrH5
 */
export var h5 = "fr-icon-h-5";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrH6
 */
export var h6 = "fr-icon-h-6";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHashtag
 */
export var hashtag = "fr-icon-hashtag";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrItalic
 */
export var italic = "fr-icon-italic";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLinkUnlink
 */
export var linkUnlink = "fr-icon-link-unlink";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLink
 */
export var link = "fr-icon-link";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrListOrdered
 */
export var listOrdered = "fr-icon-list-ordered";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrListUnordered
 */
export var listUnordered = "fr-icon-list-unordered";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrListQuestionMark
 */
export var listQuestionMark = "fr-icon-question-mark";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSeparator
 */
export var separator = "fr-icon-separator";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSpace
 */
export var space = "fr-icon-space";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSubscript
 */
export var subscript = "fr-icon-subscript";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSuperscript
 */
export var superscript = "fr-icon-superscript";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTable2
 */
export var table2 = "fr-icon-table-2";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTranslate2
 */
export var translate2 = "fr-icon-translate-2";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesEditor = [
    bold,
    highlight,
    quoteFill,
    quoteLine,
    codeView,
    fontSize,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    hashtag,
    italic,
    linkUnlink,
    link,
    listOrdered,
    listUnordered,
    listQuestionMark,
    separator,
    space,
    subscript,
    superscript,
    table2,
    translate2,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBankCardFill
 */
export var bankCardFill = "fr-icon-bank-card-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBankCardLine
 */
export var bankCardLine = "fr-icon-bank-card-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCoinFill
 */
export var coinFill = "fr-icon-coin-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGiftFill
 */
export var giftFill = "fr-icon-gift-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGiftLine
 */
export var giftLine = "fr-icon-gift-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoneyEuroBoxFill
 */
export var moneyEuroBoxFill = "fr-icon-money-euro-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoneyEuroBoxLine
 */
export var moneyEuroBoxLine = "fr-icon-money-euro-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoneyEuroCircleFill
 */
export var moneyEuroCircleFill = "fr-icon-money-euro-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoneyEuroCircleLine
 */
export var moneyEuroCircleLine = "fr-icon-money-euro-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSecurePaymentFill
 */
export var securePaymentFill = "fr-icon-secure-payment-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSecurePaymentLine
 */
export var securePaymentLine = "fr-icon-secure-payment-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShoppingBagFill
 */
export var shoppingBagFill = "fr-icon-shopping-bag-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShoppingBagLine
 */
export var shoppingBagLine = "fr-icon-shopping-bag-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShoppingCart2Fill
 */
export var shoppingCart2Fill = "fr-icon-shopping-cart-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShoppingCart2Line
 */
export var shoppingCart2Line = "fr-icon-shopping-cart-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTrophyFill
 */
export var trophyFill = "fr-icon-trophy-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTrophyLine
 */
export var trophyLine = "fr-icon-trophy-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesFinance = [
    bankCardFill,
    bankCardLine,
    coinFill,
    giftFill,
    giftLine,
    moneyEuroBoxFill,
    moneyEuroBoxLine,
    moneyEuroCircleFill,
    moneyEuroCircleLine,
    securePaymentFill,
    securePaymentLine,
    shoppingBagFill,
    shoppingBagLine,
    shoppingCart2Fill,
    shoppingCart2Line,
    trophyFill,
    trophyLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCapsuleFill
 */
export var capsuleFill = "fr-icon-capsule-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCapsuleLine
 */
export var capsuleLine = "fr-icon-capsule-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDislikeFill
 */
export var dislikeFill = "fr-icon-dislike-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDislikeLine
 */
export var dislikeLine = "fr-icon-dislike-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDossierFill
 */
export var dossierFill = "fr-icon-dossier-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDossierLine
 */
export var dossierLine = "fr-icon-dossier-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFirstAidKitFill
 */
export var firstAidKitFill = "fr-icon-first-aid-kit-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFirstAidKitLine
 */
export var firstAidKitLine = "fr-icon-first-aid-kit-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHandSanitizerFill
 */
export var handSanitizerFill = "fr-icon-hand-sanitizer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHandSanitizerLine
 */
export var handSanitizerLine = "fr-icon-hand-sanitizer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHealthBookFill
 */
export var healthBookFill = "fr-icon-health-book-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHealthBookLine
 */
export var healthBookLine = "fr-icon-health-book-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHeartFill
 */
export var heartFill = "fr-icon-heart-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHeartLine
 */
export var heartLine = "fr-icon-heart-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHeartPulseFill
 */
export var heartPulseFill = "fr-icon-heart-pulse-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHeartPulseLine
 */
export var heartPulseLine = "fr-icon-heart-pulse-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLungsFill
 */
export var lungsFill = "fr-icon-lungs-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLungsLine
 */
export var lungsLine = "fr-icon-lungs-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMedicineBottleFill
 */
export var medicineBottleFill = "fr-icon-medicine-bottle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMedicineBottleLine
 */
export var medicineBottleLine = "fr-icon-medicine-bottle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMentalHealthFill
 */
export var mentalHealthFill = "fr-icon-mental-health-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMentalHealthLine
 */
export var mentalHealthLine = "fr-icon-mental-health-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMicroscopeFill
 */
export var microscopeFill = "fr-icon-microscope-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMicroscopeLine
 */
export var microscopeLine = "fr-icon-microscope-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPsychotherapyFill
 */
export var psychotherapyFill = "fr-icon-psychotherapy-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPsychotherapyLine
 */
export var psychotherapyLine = "fr-icon-psychotherapy-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPulseLine
 */
export var pulseLine = "fr-icon-pulse-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStethoscopeFill
 */
export var stethoscopeFill = "fr-icon-stethoscope-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStethoscopeLine
 */
export var stethoscopeLine = "fr-icon-stethoscope-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSurgicalMaskFill
 */
export var surgicalMaskFill = "fr-icon-surgical-mask-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSurgicalMaskLine
 */
export var surgicalMaskLine = "fr-icon-surgical-mask-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSyringeFill
 */
export var syringeFill = "fr-icon-syringe-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSyringeLine
 */
export var syringeLine = "fr-icon-syringe-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTestTubeFill
 */
export var testTubeFill = "fr-icon-test-tube-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTestTubeLine
 */
export var testTubeLine = "fr-icon-test-tube-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThermometerFill
 */
export var thermometerFill = "fr-icon-thermometer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThermometerLine
 */
export var thermometerLine = "fr-icon-thermometer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVirusFill
 */
export var virusFill = "fr-icon-virus-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVirusLine
 */
export var virusLine = "fr-icon-virus-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesHealth = [
    capsuleFill,
    capsuleLine,
    dislikeFill,
    dislikeLine,
    dossierFill,
    dossierLine,
    firstAidKitFill,
    firstAidKitLine,
    handSanitizerFill,
    handSanitizerLine,
    healthBookFill,
    healthBookLine,
    heartFill,
    heartLine,
    heartPulseFill,
    heartPulseLine,
    lungsFill,
    lungsLine,
    medicineBottleFill,
    medicineBottleLine,
    mentalHealthFill,
    mentalHealthLine,
    microscopeFill,
    microscopeLine,
    psychotherapyFill,
    psychotherapyLine,
    pulseLine,
    stethoscopeFill,
    stethoscopeLine,
    surgicalMaskFill,
    surgicalMaskLine,
    syringeFill,
    syringeLine,
    testTubeFill,
    testTubeLine,
    thermometerFill,
    thermometerLine,
    virusFill,
    virusLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDailymotionFill
 */
export var dailymotionFill = "fr-icon-dailymotion-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDailymotionLine
 */
export var dailymotionLine = "fr-icon-dailymotion-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTiktokFill
 */
export var tiktokFill = "fr-icon-tiktok-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTiktokLine
 */
export var tiktokLine = "fr-icon-tiktok-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChromeFill
 */
export var chromeFill = "fr-icon-chrome-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChromeLine
 */
export var chromeLine = "fr-icon-chrome-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEdgeFill
 */
export var edgeFill = "fr-icon-edge-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEdgeLine
 */
export var edgeLine = "fr-icon-edge-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFacebookCircleFill
 */
export var facebookCircleFill = "fr-icon-facebook-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFacebookCircleLine
 */
export var facebookCircleLine = "fr-icon-facebook-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFirefoxFill
 */
export var firefoxFill = "fr-icon-firefox-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFirefoxLine
 */
export var firefoxLine = "fr-icon-firefox-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGithubFill
 */
export var githubFill = "fr-icon-github-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGithubLine
 */
export var githubLine = "fr-icon-github-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGoogleFill
 */
export var googleFill = "fr-icon-google-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGoogleLine
 */
export var googleLine = "fr-icon-google-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrIeFill
 */
export var ieFill = "fr-icon-ie-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrIeLine
 */
export var ieLine = "fr-icon-ie-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInstagramFill
 */
export var instagramFill = "fr-icon-instagram-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInstagramLine
 */
export var instagramLine = "fr-icon-instagram-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLinkedinBoxFill
 */
export var linkedinBoxFill = "fr-icon-linkedin-box-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLinkedinBoxLine
 */
export var linkedinBoxLine = "fr-icon-linkedin-box-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMastodonFill
 */
export var mastodonFill = "fr-icon-mastodon-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMastodonLine
 */
export var mastodonLine = "fr-icon-mastodon-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNpmjsFill
 */
export var npmjsFill = "fr-icon-npmjs-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNpmjsLine
 */
export var npmjsLine = "fr-icon-npmjs-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRemixiconFill
 */
export var remixiconFill = "fr-icon-remixicon-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRemixiconLine
 */
export var remixiconLine = "fr-icon-remixicon-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSafariFill
 */
export var safariFill = "fr-icon-safari-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSafariLine
 */
export var safariLine = "fr-icon-safari-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSlackFill
 */
export var slackFill = "fr-icon-slack-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSlackLine
 */
export var slackLine = "fr-icon-slack-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSnapchatFill
 */
export var snapchatFill = "fr-icon-snapchat-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSnapchatLine
 */
export var snapchatLine = "fr-icon-snapchat-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTelegramFill
 */
export var telegramFill = "fr-icon-telegram-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTelegramLine
 */
export var telegramLine = "fr-icon-telegram-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTwitchFill
 */
export var twitchFill = "fr-icon-twitch-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTwitchLine
 */
export var twitchLine = "fr-icon-twitch-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTwitterFill
 */
export var twitterFill = "fr-icon-twitter-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTwitterLine
 */
export var twitterLine = "fr-icon-twitter-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVimeoFill
 */
export var vimeoFill = "fr-icon-vimeo-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVimeoLine
 */
export var vimeoLine = "fr-icon-vimeo-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVuejsFill
 */
export var vuejsFill = "fr-icon-vuejs-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVuejsLine
 */
export var vuejsLine = "fr-icon-vuejs-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrYoutubeFill
 */
export var youtubeFill = "fr-icon-youtube-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrYoutubeLine
 */
export var youtubeLine = "fr-icon-youtube-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesLogo = [
    dailymotionFill,
    dailymotionLine,
    tiktokFill,
    tiktokLine,
    chromeFill,
    chromeLine,
    edgeFill,
    edgeLine,
    facebookCircleFill,
    facebookCircleLine,
    firefoxFill,
    firefoxLine,
    githubFill,
    githubLine,
    googleFill,
    googleLine,
    ieFill,
    ieLine,
    instagramFill,
    instagramLine,
    linkedinBoxFill,
    linkedinBoxLine,
    mastodonFill,
    mastodonLine,
    npmjsFill,
    npmjsLine,
    remixiconFill,
    remixiconLine,
    safariFill,
    safariLine,
    slackFill,
    slackLine,
    snapchatFill,
    snapchatLine,
    telegramFill,
    telegramLine,
    twitchFill,
    twitchLine,
    twitterFill,
    twitterLine,
    vimeoFill,
    vimeoLine,
    vuejsFill,
    vuejsLine,
    youtubeFill,
    youtubeLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAnchorFill
 */
export var anchorFill = "fr-icon-anchor-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAnchorLine
 */
export var anchorLine = "fr-icon-anchor-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBikeFill
 */
export var bikeFill = "fr-icon-bike-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBikeLine
 */
export var bikeLine = "fr-icon-bike-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBusFill
 */
export var busFill = "fr-icon-bus-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrBusLine
 */
export var busLine = "fr-icon-bus-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCarFill
 */
export var carFill = "fr-icon-car-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCarLine
 */
export var carLine = "fr-icon-car-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCaravanFill
 */
export var caravanFill = "fr-icon-caravan-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCaravanLine
 */
export var caravanLine = "fr-icon-caravan-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChargingPile2Fill
 */
export var chargingPile2Fill = "fr-icon-charging-pile-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrChargingPile2Line
 */
export var chargingPile2Line = "fr-icon-charging-pile-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCompass3Fill
 */
export var compass3Fill = "fr-icon-compass-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCompass3Line
 */
export var compass3Line = "fr-icon-compass-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCupFill
 */
export var cupFill = "fr-icon-cup-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCupLine
 */
export var cupLine = "fr-icon-cup-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEarthFill
 */
export var earthFill = "fr-icon-earth-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEarthLine
 */
export var earthLine = "fr-icon-earth-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFranceFill
 */
export var franceFill = "fr-icon-france-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFranceLine
 */
export var franceLine = "fr-icon-france-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGasStationFill
 */
export var gasStationFill = "fr-icon-gas-station-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGasStationLine
 */
export var gasStationLine = "fr-icon-gas-station-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGobletFill
 */
export var gobletFill = "fr-icon-goblet-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGobletLine
 */
export var gobletLine = "fr-icon-goblet-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMapPin2Fill
 */
export var mapPin2Fill = "fr-icon-map-pin-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMapPin2Line
 */
export var mapPin2Line = "fr-icon-map-pin-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMapPinUserFill
 */
export var mapPinUserFill = "fr-icon-map-pin-user-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMapPinUserLine
 */
export var mapPinUserLine = "fr-icon-map-pin-user-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMotorbikeFill
 */
export var motorbikeFill = "fr-icon-motorbike-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMotorbikeLine
 */
export var motorbikeLine = "fr-icon-motorbike-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPassportFill
 */
export var passportFill = "fr-icon-passport-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPassportLine
 */
export var passportLine = "fr-icon-passport-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRestaurantFill
 */
export var restaurantFill = "fr-icon-restaurant-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRestaurantLine
 */
export var restaurantLine = "fr-icon-restaurant-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRoadMapFill
 */
export var roadMapFill = "fr-icon-road-map-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRoadMapLine
 */
export var roadMapLine = "fr-icon-road-map-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSailboatFill
 */
export var sailboatFill = "fr-icon-sailboat-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSailboatLine
 */
export var sailboatLine = "fr-icon-sailboat-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShip2Fill
 */
export var ship2Fill = "fr-icon-ship-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShip2Line
 */
export var ship2Line = "fr-icon-ship-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSignalTowerFill
 */
export var signalTowerFill = "fr-icon-signal-tower-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSignalTowerLine
 */
export var signalTowerLine = "fr-icon-signal-tower-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSuitcase2Fill
 */
export var suitcase2Fill = "fr-icon-suitcase-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSuitcase2Line
 */
export var suitcase2Line = "fr-icon-suitcase-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTaxiFill
 */
export var taxiFill = "fr-icon-taxi-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTaxiLine
 */
export var taxiLine = "fr-icon-taxi-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTrainFill
 */
export var trainFill = "fr-icon-train-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTrainLine
 */
export var trainLine = "fr-icon-train-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrXFill
 */
export var xFill = "fr-icon-twitter-x-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrXLine
 */
export var xLine = "fr-icon-twitter-x-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThreadsFill
 */
export var threadsFill = "fr-icon-threads-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThreadsLine
 */
export var threadsLine = "fr-icon-threads-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPlayCircleFill
 */
export var playCircleFill = "fr-icon-play-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPlayCircleLine
 */
export var playCircleLine = "fr-icon-play-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStopCircleFill
 */
export var stopCircleFill = "fr-icon-stop-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStopCircleLine
 */
export var stopCircleLine = "fr-icon-stop-circle-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesMap = [
    anchorFill,
    anchorLine,
    bikeFill,
    bikeLine,
    busFill,
    busLine,
    carFill,
    carLine,
    caravanFill,
    caravanLine,
    chargingPile2Fill,
    chargingPile2Line,
    compass3Fill,
    compass3Line,
    cupFill,
    cupLine,
    earthFill,
    earthLine,
    franceFill,
    franceLine,
    gasStationFill,
    gasStationLine,
    gobletFill,
    gobletLine,
    mapPin2Fill,
    mapPin2Line,
    mapPinUserFill,
    mapPinUserLine,
    motorbikeFill,
    motorbikeLine,
    passportFill,
    passportLine,
    restaurantFill,
    restaurantLine,
    roadMapFill,
    roadMapLine,
    sailboatFill,
    sailboatLine,
    ship2Fill,
    ship2Line,
    signalTowerFill,
    signalTowerLine,
    suitcase2Fill,
    suitcase2Line,
    taxiFill,
    taxiLine,
    trainFill,
    trainLine,
    xFill,
    xLine,
    threadsFill,
    threadsLine,
    playCircleFill,
    playCircleLine,
    stopCircleFill,
    stopCircleLine
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCameraFill
 */
export var cameraFill = "fr-icon-camera-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCameraLine
 */
export var cameraLine = "fr-icon-camera-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrClapperboardFill
 */
export var clapperboardFill = "fr-icon-clapperboard-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrClapperboardLine
 */
export var clapperboardLine = "fr-icon-clapperboard-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEqualizerFill
 */
export var equalizerFill = "fr-icon-equalizer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEqualizerLine
 */
export var equalizerLine = "fr-icon-equalizer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFilmFill
 */
export var filmFill = "fr-icon-film-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFilmLine
 */
export var filmLine = "fr-icon-film-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGalleryFill
 */
export var galleryFill = "fr-icon-gallery-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGalleryLine
 */
export var galleryLine = "fr-icon-gallery-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHeadphoneFill
 */
export var headphoneFill = "fr-icon-headphone-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrHeadphoneLine
 */
export var headphoneLine = "fr-icon-headphone-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrImageAddFill
 */
export var imageAddFill = "fr-icon-image-add-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrImageAddLine
 */
export var imageAddLine = "fr-icon-image-add-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrImageEditFill
 */
export var imageEditFill = "fr-icon-image-edit-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrImageEditLine
 */
export var imageEditLine = "fr-icon-image-edit-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrImageFill
 */
export var imageFill = "fr-icon-image-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrImageLine
 */
export var imageLine = "fr-icon-image-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLiveFill
 */
export var liveFill = "fr-icon-live-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLiveLine
 */
export var liveLine = "fr-icon-live-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMicFill
 */
export var micFill = "fr-icon-mic-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMicLine
 */
export var micLine = "fr-icon-mic-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMusic2Fill
 */
export var music2Fill = "fr-icon-music-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMusic2Line
 */
export var music2Line = "fr-icon-music-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNotification3Fill
 */
export var notification3Fill = "fr-icon-notification-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNotification3Line
 */
export var notification3Line = "fr-icon-notification-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPauseCircleFill
 */
export var pauseCircleFill = "fr-icon-pause-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPauseCircleLine
 */
export var pauseCircleLine = "fr-icon-pause-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVolumeDownFill
 */
export var volumeDownFill = "fr-icon-volume-down-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVolumeDownLine
 */
export var volumeDownLine = "fr-icon-volume-down-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVolumeMuteFill
 */
export var volumeMuteFill = "fr-icon-volume-mute-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVolumeMuteLine
 */
export var volumeMuteLine = "fr-icon-volume-mute-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVolumeUpFill
 */
export var volumeUpFill = "fr-icon-volume-up-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrVolumeUpLine
 */
export var volumeUpLine = "fr-icon-volume-up-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesMedia = [
    cameraFill,
    cameraLine,
    clapperboardFill,
    clapperboardLine,
    equalizerFill,
    equalizerLine,
    filmFill,
    filmLine,
    galleryFill,
    galleryLine,
    headphoneFill,
    headphoneLine,
    imageAddFill,
    imageAddLine,
    imageEditFill,
    imageEditLine,
    imageFill,
    imageLine,
    liveFill,
    liveLine,
    micFill,
    micLine,
    music2Fill,
    music2Line,
    notification3Fill,
    notification3Line,
    pauseCircleFill,
    pauseCircleLine,
    volumeDownFill,
    volumeDownLine,
    volumeMuteFill,
    volumeMuteLine,
    volumeUpFill,
    volumeUpLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLeafFill
 */
export var leafFill = "fr-icon-leaf-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLeafLine
 */
export var leafLine = "fr-icon-leaf-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLightbulbFill
 */
export var lightbulbFill = "fr-icon-lightbulb-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLightbulbLine
 */
export var lightbulbLine = "fr-icon-lightbulb-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPlantFill
 */
export var plantFill = "fr-icon-plant-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrPlantLine
 */
export var plantLine = "fr-icon-plant-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRecycleFill
 */
export var recycleFill = "fr-icon-recycle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRecycleLine
 */
export var recycleLine = "fr-icon-recycle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrScales3Fill
 */
export var scales3Fill = "fr-icon-scales-3-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrScales3Line
 */
export var scales3Line = "fr-icon-scales-3-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSeedlingFill
 */
export var seedlingFill = "fr-icon-seedling-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSeedlingLine
 */
export var seedlingLine = "fr-icon-seedling-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUmbrellaFill
 */
export var umbrellaFill = "fr-icon-umbrella-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUmbrellaLine
 */
export var umbrellaLine = "fr-icon-umbrella-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesOthers = [
    leafFill,
    leafLine,
    lightbulbFill,
    lightbulbLine,
    plantFill,
    plantLine,
    recycleFill,
    recycleLine,
    scales3Fill,
    scales3Line,
    seedlingFill,
    seedlingLine,
    umbrellaFill,
    umbrellaLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowLeftSFill
 */
export var arrowLeftSFill = "fr-icon-arrow-left-s-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowLeftSLine
 */
export var arrowLeftSLine = "fr-icon-arrow-left-s-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightSFill
 */
export var arrowRightSFill = "fr-icon-arrow-right-s-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightSLine
 */
export var arrowRightSLine = "fr-icon-arrow-right-s-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrErrorFill
 */
export var errorFill = "fr-icon-error-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrErrorLine
 */
export var errorLine = "fr-icon-error-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInfoFill
 */
export var infoFill = "fr-icon-info-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInfoLine
 */
export var infoLine = "fr-icon-info-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSuccessFill
 */
export var successFill = "fr-icon-success-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSuccessLine
 */
export var successLine = "fr-icon-success-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrWarningFill
 */
export var warningFill = "fr-icon-warning-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrWarningLine
 */
export var warningLine = "fr-icon-warning-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThemeFill
 */
export var themeFill = "fr-icon-theme-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAddCircleFill
 */
export var addCircleFill = "fr-icon-add-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAddCircleLine
 */
export var addCircleLine = "fr-icon-add-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAddLine
 */
export var addLine = "fr-icon-add-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAlarmWarningFill
 */
export var alarmWarningFill = "fr-icon-alarm-warning-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAlarmWarningLine
 */
export var alarmWarningLine = "fr-icon-alarm-warning-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAlertFill
 */
export var alertFill = "fr-icon-alert-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAlertLine
 */
export var alertLine = "fr-icon-alert-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowDownFill
 */
export var arrowDownFill = "fr-icon-arrow-down-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowDownLine
 */
export var arrowDownLine = "fr-icon-arrow-down-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowDownSFill
 */
export var arrowDownSFill = "fr-icon-arrow-down-s-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowDownSLine
 */
export var arrowDownSLine = "fr-icon-arrow-down-s-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowGoBackFill
 */
export var arrowGoBackFill = "fr-icon-arrow-go-back-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowGoBackLine
 */
export var arrowGoBackLine = "fr-icon-arrow-go-back-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowGoForwardFill
 */
export var arrowGoForwardFill = "fr-icon-arrow-go-forward-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowGoForwardLine
 */
export var arrowGoForwardLine = "fr-icon-arrow-go-forward-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowLeftFill
 */
export var arrowLeftFill = "fr-icon-arrow-left-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowLeftLine
 */
export var arrowLeftLine = "fr-icon-arrow-left-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightFill
 */
export var arrowRightFill = "fr-icon-arrow-right-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightLine
 */
export var arrowRightLine = "fr-icon-arrow-right-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightUpLine
 */
export var arrowRightUpLine = "fr-icon-arrow-right-up-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowUpFill
 */
export var arrowUpFill = "fr-icon-arrow-up-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowUpLine
 */
export var arrowUpLine = "fr-icon-arrow-up-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowUpSFill
 */
export var arrowUpSFill = "fr-icon-arrow-up-s-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowUpSLine
 */
export var arrowUpSLine = "fr-icon-arrow-up-s-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCheckLine
 */
export var checkLine = "fr-icon-check-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCheckboxCircleFill
 */
export var checkboxCircleFill = "fr-icon-checkbox-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCheckboxCircleLine
 */
export var checkboxCircleLine = "fr-icon-checkbox-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCheckboxFill
 */
export var checkboxFill = "fr-icon-checkbox-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCheckboxLine
 */
export var checkboxLine = "fr-icon-checkbox-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloseCircleFill
 */
export var closeCircleFill = "fr-icon-close-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloseCircleLine
 */
export var closeCircleLine = "fr-icon-close-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloseLine
 */
export var closeLine = "fr-icon-close-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDeleteFill
 */
export var deleteFill = "fr-icon-delete-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDeleteLine
 */
export var deleteLine = "fr-icon-delete-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDownloadFill
 */
export var downloadFill = "fr-icon-download-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrDownloadLine
 */
export var downloadLine = "fr-icon-download-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrErrorWarningFill
 */
export var errorWarningFill = "fr-icon-error-warning-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrErrorWarningLine
 */
export var errorWarningLine = "fr-icon-error-warning-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrExternalLinkFill
 */
export var externalLinkFill = "fr-icon-external-link-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrExternalLinkLine
 */
export var externalLinkLine = "fr-icon-external-link-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEyeFill
 */
export var eyeFill = "fr-icon-eye-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEyeLine
 */
export var eyeLine = "fr-icon-eye-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEyeOffFill
 */
export var eyeOffFill = "fr-icon-eye-off-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrEyeOffLine
 */
export var eyeOffLine = "fr-icon-eye-off-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFilterFill
 */
export var filterFill = "fr-icon-filter-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFilterLine
 */
export var filterLine = "fr-icon-filter-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowLeftSFirstLine
 */
export var arrowLeftSFirstLine = "fr-icon-arrow-left-s-first-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowLeftSLineDouble
 */
export var arrowLeftSLineDouble = "fr-icon-arrow-left-s-line-double";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightSLastLine
 */
export var arrowRightSLastLine = "fr-icon-arrow-right-s-last-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrArrowRightSLineDouble
 */
export var arrowRightSLineDouble = "fr-icon-arrow-right-s-line-double";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInformationFill
 */
export var informationFill = "fr-icon-information-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrInformationLine
 */
export var informationLine = "fr-icon-information-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLockFill
 */
export var lockFill = "fr-icon-lock-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLockLine
 */
export var lockLine = "fr-icon-lock-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLockUnlockFill
 */
export var lockUnlockFill = "fr-icon-lock-unlock-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLockUnlockLine
 */
export var lockUnlockLine = "fr-icon-lock-unlock-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLogoutBoxRFill
 */
export var logoutBoxRFill = "fr-icon-logout-box-r-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrLogoutBoxRLine
 */
export var logoutBoxRLine = "fr-icon-logout-box-r-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMenu2Fill
 */
export var menu2Fill = "fr-icon-menu-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMenuFill
 */
export var menuFill = "fr-icon-menu-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoreFill
 */
export var moreFill = "fr-icon-more-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoreLine
 */
export var moreLine = "fr-icon-more-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNotificationBadgeFill
 */
export var notificationBadgeFill = "fr-icon-notification-badge-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrNotificationBadgeLine
 */
export var notificationBadgeLine = "fr-icon-notification-badge-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuestionFill
 */
export var questionFill = "fr-icon-question-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrQuestionLine
 */
export var questionLine = "fr-icon-question-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRefreshFill
 */
export var refreshFill = "fr-icon-refresh-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrRefreshLine
 */
export var refreshLine = "fr-icon-refresh-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSearchFill
 */
export var searchFill = "fr-icon-search-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSearchLine
 */
export var searchLine = "fr-icon-search-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSettings5Fill
 */
export var settings5Fill = "fr-icon-settings-5-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSettings5Line
 */
export var settings5Line = "fr-icon-settings-5-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShieldFill
 */
export var shieldFill = "fr-icon-shield-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrShieldLine
 */
export var shieldLine = "fr-icon-shield-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStarFill
 */
export var starFill = "fr-icon-star-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStarLine
 */
export var starLine = "fr-icon-star-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStarSFill
 */
export var starSFill = "fr-icon-star-s-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrStarSLine
 */
export var starSLine = "fr-icon-star-s-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrSubtractLine
 */
export var subtractLine = "fr-icon-subtract-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThumbDownFill
 */
export var thumbDownFill = "fr-icon-thumb-down-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThumbDownLine
 */
export var thumbDownLine = "fr-icon-thumb-down-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThumbUpFill
 */
export var thumbUpFill = "fr-icon-thumb-up-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrThumbUpLine
 */
export var thumbUpLine = "fr-icon-thumb-up-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTimeFill
 */
export var timeFill = "fr-icon-time-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTimeLine
 */
export var timeLine = "fr-icon-time-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTimerFill
 */
export var timerFill = "fr-icon-timer-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTimerLine
 */
export var timerLine = "fr-icon-timer-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUpload2Fill
 */
export var upload2Fill = "fr-icon-upload-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUpload2Line
 */
export var upload2Line = "fr-icon-upload-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUploadFill
 */
export var uploadFill = "fr-icon-upload-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUploadLine
 */
export var uploadLine = "fr-icon-upload-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrZoomInFill
 */
export var zoomInFill = "fr-icon-zoom-in-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrZoomInLine
 */
export var zoomInLine = "fr-icon-zoom-in-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrZoomOutFill
 */
export var zoomOutFill = "fr-icon-zoom-out-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrZoomOutLine
 */
export var zoomOutLine = "fr-icon-zoom-out-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesSystem = [
    arrowLeftSFill,
    arrowLeftSLine,
    arrowRightSFill,
    arrowRightSLine,
    errorFill,
    errorLine,
    infoFill,
    infoLine,
    successFill,
    successLine,
    warningFill,
    warningLine,
    themeFill,
    addCircleFill,
    addCircleLine,
    addLine,
    alarmWarningFill,
    alarmWarningLine,
    alertFill,
    alertLine,
    arrowDownFill,
    arrowDownLine,
    arrowDownSFill,
    arrowDownSLine,
    arrowGoBackFill,
    arrowGoBackLine,
    arrowGoForwardFill,
    arrowGoForwardLine,
    arrowLeftFill,
    arrowLeftLine,
    arrowRightFill,
    arrowRightLine,
    arrowRightUpLine,
    arrowUpFill,
    arrowUpLine,
    arrowUpSFill,
    arrowUpSLine,
    checkLine,
    checkboxCircleFill,
    checkboxCircleLine,
    checkboxFill,
    checkboxLine,
    closeCircleFill,
    closeCircleLine,
    closeLine,
    deleteFill,
    deleteLine,
    downloadFill,
    downloadLine,
    errorWarningFill,
    errorWarningLine,
    externalLinkFill,
    externalLinkLine,
    eyeFill,
    eyeLine,
    eyeOffFill,
    eyeOffLine,
    filterFill,
    filterLine,
    arrowLeftSFirstLine,
    arrowLeftSLineDouble,
    arrowRightSLastLine,
    arrowRightSLineDouble,
    informationFill,
    informationLine,
    lockFill,
    lockLine,
    lockUnlockFill,
    lockUnlockLine,
    logoutBoxRFill,
    logoutBoxRLine,
    menu2Fill,
    menuFill,
    moreFill,
    moreLine,
    notificationBadgeFill,
    notificationBadgeLine,
    questionFill,
    questionLine,
    refreshFill,
    refreshLine,
    searchFill,
    searchLine,
    settings5Fill,
    settings5Line,
    shieldFill,
    shieldLine,
    starFill,
    starLine,
    starSFill,
    starSLine,
    subtractLine,
    thumbDownFill,
    thumbDownLine,
    thumbUpFill,
    thumbUpLine,
    timeFill,
    timeLine,
    timerFill,
    timerLine,
    upload2Fill,
    upload2Line,
    uploadFill,
    uploadLine,
    zoomInFill,
    zoomInLine,
    zoomOutFill,
    zoomOutLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAccountCircleFill
 */
export var accountCircleFill = "fr-icon-account-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAccountCircleLine
 */
export var accountCircleLine = "fr-icon-account-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAccountFill
 */
export var accountFill = "fr-icon-account-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAccountLine
 */
export var accountLine = "fr-icon-account-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAccountPinCircleFill
 */
export var accountPinCircleFill = "fr-icon-account-pin-circle-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAccountPinCircleLine
 */
export var accountPinCircleLine = "fr-icon-account-pin-circle-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAdminFill
 */
export var adminFill = "fr-icon-admin-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrAdminLine
 */
export var adminLine = "fr-icon-admin-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGroupFill
 */
export var groupFill = "fr-icon-group-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrGroupLine
 */
export var groupLine = "fr-icon-group-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrParentFill
 */
export var parentFill = "fr-icon-parent-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrParentLine
 */
export var parentLine = "fr-icon-parent-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTeamFill
 */
export var teamFill = "fr-icon-team-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrTeamLine
 */
export var teamLine = "fr-icon-team-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserAddFill
 */
export var userAddFill = "fr-icon-user-add-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserAddLine
 */
export var userAddLine = "fr-icon-user-add-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserFill
 */
export var userFill = "fr-icon-user-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserLine
 */
export var userLine = "fr-icon-user-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserHeartFill
 */
export var userHeartFill = "fr-icon-user-heart-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserHeartLine
 */
export var userHeartLine = "fr-icon-user-heart-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserSearchFill
 */
export var userSearchFill = "fr-icon-user-search-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserSearchLine
 */
export var userSearchLine = "fr-icon-user-search-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserSettingFill
 */
export var userSettingFill = "fr-icon-user-setting-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserSettingLine
 */
export var userSettingLine = "fr-icon-user-setting-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserStarFill
 */
export var userStarFill = "fr-icon-user-star-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrUserStarLine
 */
export var userStarLine = "fr-icon-user-star-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesUser = [
    accountCircleFill,
    accountCircleLine,
    accountFill,
    accountLine,
    accountPinCircleFill,
    accountPinCircleLine,
    adminFill,
    adminLine,
    groupFill,
    groupLine,
    parentFill,
    parentLine,
    teamFill,
    teamLine,
    userAddFill,
    userAddLine,
    userFill,
    userLine,
    userHeartFill,
    userHeartLine,
    userSearchFill,
    userSearchLine,
    userSettingFill,
    userSettingLine,
    userStarFill,
    userStarLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloudy2Fill
 */
export var cloudy2Fill = "fr-icon-cloudy-2-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrCloudy2Line
 */
export var cloudy2Line = "fr-icon-cloudy-2-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFlashlightFill
 */
export var flashlightFill = "fr-icon-flashlight-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrFlashlightLine
 */
export var flashlightLine = "fr-icon-flashlight-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoonFill
 */
export var moonFill = "fr-icon-moon-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Utiliser : iconDsfrMoonLine
 */
export var moonLine = "fr-icon-moon-line";
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIconesWeather = [
    cloudy2Fill,
    cloudy2Line,
    flashlightFill,
    flashlightLine,
    moonFill,
    moonLine,
];
/**
 * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
 */
export var listeIcones = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], listeIconesBuilding, true), listeIconesBusiness, true), listeIconesCommunication, true), listeIconesDesign, true), listeIconesDevelopment, true), listeIconesDevice, true), listeIconesDocument, true), listeIconesEditor, true), listeIconesFinance, true), listeIconesHealth, true), listeIconesLogo, true), listeIconesMap, true), listeIconesMedia, true), listeIconesOthers, true), listeIconesSystem, true), listeIconesUser, true), listeIconesWeather, true);
